/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/1
 * @updateTime 2021/9/1
 * @decription 申请复议 =》 添加复议申请人表单组件入口js
 */
// 表单布局
import acLayoutForm from '@/components/app/layout/form/index.vue';
import {columnsSFZ, columnsMZ, columnsGZDW, columnsRYLX,columnsSSDW} from '@/utils/option.js';
import validate from '@/utils/validator/validator';
import {
    typeMz,
    typeSfzjlx,
    typeGzdwlx,
    typeSsdW
} from '@/filters/index';
import {
    PhoneRule,
    ZjhmRule,
    XmRule,
    mzRule,
    xbRule,
    NlRule,
    zjlxRule,
    TxdzRule,
    QymcRule,
    TyshxydmRule,
    QyfrRule,
    GddhRule,
    ssdwRule
} from '@/utils/validator/rules';
import {dateFormat} from '@/utils/dateFormatter';
import {checkIdentify, getIDData, createId} from '@/utils/common';
import {mapGetters} from "vuex";

export default {
    name: 'addSQR',
    data() {
        return {
            // 申请人id
            fySqrId:'',
            // 诉讼类型为1的表单数据
            formData_1: {},
            // 诉讼类型为2的表单数据
            formData_2: {},
            // 诉讼类型为3的表单数据
            formData_3: {},
            // 表单数据
            formData: {
                // 申请人id
                cId: '',
                // 复议id
                cFyId: this.fyid,
                // 申请人姓名
                cSqrxm: '',
                // 性别
                cSqrxb: '1',
                // 民族
                nMz: '1',
                // 民族文字描述
                nMzText: '汉族',
                //诉讼地位
                nSsdw: '2',
                //诉讼地位文字
                nSsdwText: '原申请人',
                // 年龄
                nNl: '',
                // 申请人出生日期,
                dtSqrbirthday: '',
                // 申请人出生日期文字描述
                dtSqrbirthdayText: '',
                // 证件类型
                cZjlx: '1',
                // 证件类型汉字描述
                cZjlxText: '居民身份证',
                // 证件号码
                cZjh: '',
                // 固定电话
                cGh: '',
                // 手机号码
                cPhonone: '',
                // 经常居住地
                cTxdz: '',
                // 单位名称
                cQymc: '',
                // 统一社会信用代码
                cQyzzjgdm: '',
                // 单位性质
                cDwxz: '',
                // 单位性质文字描述
                cDwxzText: '',
                // 企业法人
                cQyfr: '',
                // 申请人类型
                cSqrlx: '1',
                // 申请人类型文本
                cSqrlxText: '自然人'
            },
            // 申请人类型
            cSqrlx: '1',
            // 申请人类型描述
            cSqrlxText: '自然人',
            // 申请人类型
            showSqrlx: false,
            columnsSFZ: columnsSFZ,
            columnsMZ: columnsMZ,
            columnsGZDW: columnsGZDW,
            columnsRYLX: columnsRYLX,
            columnsSSDW:columnsSSDW,
            showSSDW:false,
            showZJLXPicker: false,
            showDatePicker: false,
            currentDate: new Date(),
            showMZPicker: false,
            showGZDWPicker: false,
            minDate: new Date("1800-01-01"),
            maxDate: new Date(),
            // 保存按钮是否可以点击
            saveBtnClickable: true,
        }
    },
    props: {
        // 复议id
        fyid: String,
        // 表单数据
        data: Object
    },
    computed: {
        // 诉讼地位
        ...mapGetters(['codeList_702000'])
    },
    components: {
        acLayoutForm
    },
    methods: {

        /**
         * 初始化代码值
         * @returns {void}
         * */
        initCodeType() {
            // 诉讼地位
            this.$store.dispatch('GetCodeType', 702000);
        },

        /**
         * 重置数据
         * @returns {void}
         * */
        resetData() {
            // 申请人id
            this.fySqrId = '';
            // 诉讼类型为1的表单数据
            this.formData_1 = {};
            // 诉讼类型为2的表单数据
            this.formData_2 = {};
            // 诉讼类型为3的表单数据
            this.formData_3 = {};
            // 表单数据
            this.formData = {
                // 申请人id
                cId: '',
                    // 复议id
                    cFyId: this.fyid,
                    // 申请人姓名
                    cSqrxm: '',
                    // 性别
                    cSqrxb: '1',
                    // 民族
                    nMz: '1',
                    // 民族文字描述
                    nMzText: '汉族',
                    //诉讼地位
                    nSsdw:'1',
                    //诉讼地位文字
                    nSsdwText:'原申请人',
                    // 年龄
                    nNl: '',
                    // 申请人出生日期,
                    dtSqrbirthday: '',
                    // 申请人出生日期文字描述
                    dtSqrbirthdayText: '',
                    // 证件类型
                    cZjlx: '1',
                    // 证件类型汉字描述
                    cZjlxText: '居民身份证',
                    // 证件号码
                    cZjh: '',
                    // 固定电话
                    cGh: '',
                    // 手机号码
                    cPhonone: '',
                    // 经常居住地
                    cTxdz: '',
                    // 单位名称
                    cQymc: '',
                    // 统一社会信用代码
                    cQyzzjgdm: '',
                    // 单位性质
                    cDwxz: '',
                    // 单位性质文字描述
                    cDwxzText: '',
                    // 企业法人
                    cQyfr: '',
                    // 申请人类型
                    cSqrlx: '1',
                    // 申请人类型文本
                    cSqrlxText: '自然人'
            };
            // 申请人类型
            this.cSqrlx = 1;
            // 申请人类型描述
            this.cSqrlxText = '自然人';
        },
        /**
         * 选择了申请人类型
         * @param {Object} item 申请人信息项数据
         * @returns {void}
         * */
        onSelectSqrlx(item) {
            // 如果申请人类型不变，则直接返回
            if (item.keyId == this.cSqrlx) {
                return;
            }
            // 申请人类型赋值
            this.cSqrlx = item.keyId;
            // 申请人类型文本赋值
            this.cSqrlxText = item.text;

            // 下面操作，主要是为了点击确认之后，在列表页面不用再转化赋值
            // 申请人类型
            this[`formData_${this.cSqrlx}`].cSqrlx = item.keyId;
            // 申请人类型文本赋值
            this[`formData_${this.cSqrlx}`].cSqrlxText = item.text;
            // 隐藏申请类型选择面板
            this.showSqrlx = false;
        },

        /**
         * 选择诉讼地位
         * @param {Object} item 诉讼地位信息项数据
         * @returns {void}
         * */
        onSSDWconfirm(item){
            this.showSSDW = false;
            this[`formData_${this.cSqrlx}`].nSsdwText = item.text;
            this[`formData_${this.cSqrlx}`].nSsdw = item.keyId;
        },

        /**
         * 选择证件类型
         * @param {Object} item 证件类型信息项数据
         * @returns {void}
         * */
        onZJLXConfirm: function (item) {
            this[`formData_${this.cSqrlx}`].cZjlx = item.keyId;
            this[`formData_${this.cSqrlx}`].cZjlxText = item.text;
            this.showZJLXPicker = false;
        },

        /**
         * 选择出生日期
         * @returns {void}
         * */
        onDatePickerConfirm: function () {
            this.currentDate = new Date(this.currentDate.setHours(8));
            this[`formData_${this.cSqrlx}`].dtSqrbirthday = dateFormat(this.currentDate, "yyyy-MM-dd");
            this[`formData_${this.cSqrlx}`].dtSqrbirthdayText = this[`formData_${this.cSqrlx}`].dtSqrbirthday;
            this.showDatePicker = false;
        },

        /**
         * 解析身份证号
         * @returns {void}
         * */
        identifyAnalyzer: function () {
            // 如果证件类型不为1 身份证号，则直接返回
            if (this[`formData_${this.cSqrlx}`].cZjlx != 1) {
                return;
            }
            // 证件号码
            let zjhm = this[`formData_${this.cSqrlx}`].cZjh;
            // 校验证件号码是否正确
            let correct = checkIdentify(zjhm);
            if (correct) {
                // 身份证号格式正确, 向服务器查询 生日, 性别, 年龄 信息
                getIDData(zjhm).then(res => {
                    let data = res.data;
                    this[`formData_${this.cSqrlx}`] = {
                        ...this[`formData_${this.cSqrlx}`],
                        ...{
                            dtSqrbirthday: data.cBirthdate,
                            nNl: data.nAge,
                            cSqrxb: data.cSex
                        }
                    };
                });
            }
        },

        /**
         * 选择民族
         * @param {Object} item 民族信息项数据
         * @returns {void}
         * */
        onMZConfirm: function (item) {
            this[`formData_${this.cSqrlx}`].nMz = item.keyId;
            this[`formData_${this.cSqrlx}`].nMzText = item.text;
            this.showMZPicker = false;
        },

        /**
         * 选择单位性质
         * @param {Object} item 单位性质信息项数据
         * @returns {void}
         * */
        onGZDWConfirm: function (item) {
            this[`formData_${this.cSqrlx}`].cDwxz = item.keyId;
            this[`formData_${this.cSqrlx}`].cDwxzText = item.text;
            this.showGZDWPicker = false;
        },

        /**
         * 获取参数
         * */
        getParams() {
            return this[`formData_${this.cSqrlx}`];
        },

        /**
         * 返回事件
         * @returns {void}
         * */
        back() {
            this.$emit('cancel');
        },

        /**
         * 刷新操作
         * @returns {void}
         * */
        refresh() {
            // 重置数据
            this.resetData();
            // 重新走初始化流程
            this.init();
            // 返回顶部
            this.$refs.con && this.$refs.con.goToTop();
        },

        /**
         * 添加/确认按钮点击事件
         * @returns {void}
         * */
        addSqrAndReturn: function () {
            // 验证表单数据
            this.validateFormData().then(() => {
                // 向上分发确认事件
                this.$emit('confirm', this[`formData_${this.cSqrlx}`]);
            }).catch(() => {
                console.log('校验不通过！');
            });
        },

        /**
         * 确认并添加按钮点击事件
         * @returns {void}
         * */
        addSqrAndContinue: function () {
            // 验证表单数据
            this.validateFormData().then(() => {
                // 向上分发确认并继续事件
                this.$emit('confirm-continue', this[`formData_${this.cSqrlx}`]);
                // 刷新当前表单
                this.refresh();
            }).catch(() => {
                console.log('校验不通过！');
            });
        },

        /**
         * 申请类型为1 自然人的表单验证
         * @returns {Promise}
         * */
        validateFormData_1: function() {
            // 自然人校验规则
            const descriptor = {
                // 姓名
                cSqrxm: new XmRule(true),
                //诉讼地位
                nSsdw: ssdwRule,
                // 证件类型
                cZjlx: zjlxRule,
                // 证件号码
                cZjh: new ZjhmRule(this.formData_1.cZjlx, true),
                // dtSqrBirthday: csrqRule, // 出生日期非必填
                nNl: new NlRule(true),
                // 性别
                cSqrxb: xbRule,
                // 民族
                nMz: mzRule,
                // 手机号码
                cPhonone: new PhoneRule(true),
                // 固定电话
                cGh: new GddhRule(false),
                // 经常居住地
                cTxdz: new TxdzRule(this.cSqrlx, true)
            };
            let validated = validate(descriptor, this.formData_1);
            return validated;
        },

        /**
         * 申请类型为 2 法人的表单验证
         * @returns {Promise}
         * */
        validateFormData_2: function() {
            // 自然人校验规则
            const descriptor = {
                // 单位名称
                cQymc: new QymcRule(true),
                //诉讼地位
                nSsdw: ssdwRule,
                // dwxz: dwxzRule,
                // 统一社会信用代码
                cQyzzjgdm: new TyshxydmRule(true),
                // 法定代表人
                cQyfr: new QyfrRule(this.cSqrlx, true),
                // 手机号码
                cPhonone: new PhoneRule(true),
                // 固定电话
                cGh: new GddhRule(false),
                // 单位地址
                cTxdz: new TxdzRule(this.cSqrlx, true)
            };
            let validated = validate(descriptor, this.formData_2);
            return validated;
        },

        /**
         * 申请类型为 3 非法人组织的表单验证
         * @returns {Promise}
         * */
        validateFormData_3: function() {
            // 自然人校验规则
            const descriptor = {
                // 单位名称
                cQymc: new QymcRule(true),
                //诉讼地位
                nSsdw:ssdwRule,
                // 统一社会信用代码
                cQyzzjgdm: new TyshxydmRule(true),
                // 法定代表人
                cQyfr: new QyfrRule(this.cSqrlx, true),
                // 手机号码
                cPhonone: new PhoneRule(true),
                // 固定电话
                cGh: new GddhRule(false),
                // 单位地址
                cTxdz: new TxdzRule(this.cSqrlx, true)
            };
            let validated = validate(descriptor, this.formData_3);
            return validated;
        },

        /**
         * 验证表单数据
         * @returns {Promise}
         * */
        validateFormData: function () {
            return new Promise((resolve, reject) => {
                // 对应的验证规则
                const validated = this[`validateFormData_${this.cSqrlx}`]();
                validated.then(() => {
                   // 校验通过
                   resolve();
                }).catch(() => {
                    console.log('请完整填写表单数据');
                    reject();
                });
            });
        },

        /**
         * 初始化方法
         * @returns {void}
         * */
        init() {
            // 如果数据存在
            if (this.data) {
                // 表单数据赋值默认的表单数据
                this.formData_1 = {
                    ...this.formData
                };
                this.formData_2 = {
                    ...this.formData
                };
                this.formData_3 = {
                    ...this.formData
                };
                // 数据进行赋值
                const _formData = {
                    ...this.data
                };
                // 民族需要转化成文本
                _formData.nMzText = typeMz(_formData.nMz);
                // 证件类型
                _formData.cZjlxText = typeSfzjlx(_formData.cZjlx);
                // 单位性质
                _formData.cDwxzText = typeGzdwlx(_formData.cDwxz);
                // 诉讼地位
                _formData.nSsdwText = typeSsdW(_formData.nSsdw);
                // 申请人id赋值
                this.fySqrId = _formData.cId;
                // 申请人类型
                this.cSqrlx = _formData.cSqrlx;
                // 复议申请人类型
                this.cSqrlxText = _formData.cSqrlxText;
                // 表单id赋值
                this.formData_1.cId = _formData.cId;
                // 表单id赋值
                this.formData_2.cId = _formData.cId;
                // 表单id赋值
                this.formData_3.cId = _formData.cId;
                // 表单赋值
                this[`formData_${_formData.cSqrlx}`] = _formData;
            } else {
                // 创建id
                createId().then(id => {
                    this.formData.cId = id;
                    // 表单数据赋值默认的表单数据
                    this.formData_1 = {
                        ...this.formData
                    };
                    this.formData_2 = {
                        ...this.formData
                    };
                    this.formData_3 = {
                        ...this.formData
                    };
                });
            }
        }
    },
    created() {
        // 初始化代码值
        this.initCodeType();
        // 初始化方法
        this.init();
    }
}
